module.exports = __webpack_public_path__ + "img/11.1cef9b68.jpg";